import { parsePhoneNumber } from 'awesome-phonenumber';

export const useParsePhoneNumber = () => {
  const isValid = (phone?: string | null) =>
    parsePhoneNumber(`+${phone}`)?.valid;

  return { isValid };
};
